import { getContextFromUrl } from 'config/Config';

export const texts = {
    PAGE_TITLE: 'Solicitar restauración de contraseña',
    confirmacion: {
        titulo: 'Solicitud de cambio de contraseña',
        mensaje_a: 'Recibirá un correo en la dirección <b>',
        mensaje_b: '</b> con el enlace donde deberá introducir su nueva contraseña.<br>Dispones de 30 minutos para realizar el cambio.'
    }
}

export const objComponentFormio = {    
    aliasFormulario: 'solicitarContrasena',
    sp: {
        complete: 'Formulario cumplimentado correctamente',
        error: 'Hubo un problema',
        next: 'Siguiente',
        previous: 'Atrás',
        cancel: 'Cancelar',
        submit: 'Guardar',
        required: 'Es obligatorio rellenar este campo',
        confirmCancel: '¿Estás seguro que quieres cancelar?',
        submitError: 'Por favor revise el formulario y corrija todos los errores.',
        pattern: 'El valor no cumple con el patrón requerido',
        email: 'Debe ser una dirección de correo electrónico válida',
        invalid_regex: 'El valor insertado no es válido'
    }
}

export const cruds = {
    loginRequest: {
        resource: 'login-usuario',
        url: '/resetPassword'
    }
}

export const properties = {
    IMAGEN_OK: `${getContextFromUrl()}` + 'email.png',
    IMAGEN_ERROR : `${getContextFromUrl()}` + 'exclamation-triangle-solid.svg'
}
